'use strict';

var _ = require('lodash');
var SeasonalityReviewCalendarModalController = function SeasonalityReviewCalendarModalController($scope, momentService) {
  $scope.years = [];
  $scope.startAt = 0;
  $scope.dateToColorMap = {};
  function prepareYears() {
    var years = [];
    var currentYear = momentService.now(momentService.FIELD.DEPARTURE_DATE).year();
    years.push($scope.displayedCalendar.startDepartureDate.year());
    years.push($scope.displayedCalendar.endDepartureDate.year());
    years.push(currentYear);
    years.push(currentYear + 1);
    return _.uniq(years);
  }
  $scope.years = prepareYears();
};
SeasonalityReviewCalendarModalController.$inject = ['$scope', 'MomentService'];
module.exports = SeasonalityReviewCalendarModalController;